/** The compass labels the user can click, and the bearing each one faces. */
export const COMPASS_DIRECTIONS = [
  { label: 'N', name: 'north', bearing: 0 },
  { label: 'NE', name: 'north-east', bearing: 45 },
  { label: 'E', name: 'east', bearing: 90 },
  { label: 'SE', name: 'south-east', bearing: 135 },
  { label: 'S', name: 'south', bearing: 180 },
  { label: 'SW', name: 'south-west', bearing: 225 },
  { label: 'W', name: 'west', bearing: 270 },
  { label: 'NW', name: 'north-west', bearing: 315 }
] as const

export type CompassDirection = (typeof COMPASS_DIRECTIONS)[number]

export const isCardinal = ({ label }: CompassDirection): boolean =>
  label.length === 1

export const toRotateLabel = ({ name }: CompassDirection): string =>
  `Rotate map to face ${name}`

/**
 * Turns a Mapbox bearing, which runs from -180 to 180, into the whole degree
 * the compass shows, from 0 to 359.
 */
export const toCompassDegrees = (mapBearing: number): number =>
  ((Math.round(mapBearing) % 360) + 360) % 360

const DEGREE_MARK_STEP = 30

/** The degree numbers around the outside of the expanded dial. */
export const DEGREE_MARKS: readonly number[] = Array.from(
  { length: 360 / DEGREE_MARK_STEP },
  (_, index) => index * DEGREE_MARK_STEP
)
